import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import TimeSlot from './TimeSlot';
import { dayOfWeek2Text, month2Text } from '../Utils';
import { CALENDAR_DAY_END_HOUR, CALENDAR_DAY_START_HOUR, SLOT_HEIGHT, TASK_AVAILABILITY_TYPE } from './Constants';
import Task from './Task';
import { calculatePositionFromTime, isToday } from './Utils';
import Booking from './Booking';

const DayColumn = ({ calendar, day, month, year, tasks, bookings, onAddAvailability, onTaskClick, onBookingClick }) => {
  const hours = Array.from({ length: CALENDAR_DAY_END_HOUR - CALENDAR_DAY_START_HOUR }, (_, i) => CALENDAR_DAY_START_HOUR + i);
  const [tempTask, setTempTask] = useState(null); // Holds the temporary task being created
  const [currentTime, setCurrentTime] = useState(new Date());
  const londonTime = new Date(currentTime.toLocaleString('en-US', { timeZone: 'Europe/London' }));
  const slotHeight = SLOT_HEIGHT;
  const handleMouseDown = (e) => {
    const startY = e.clientY - e.currentTarget.getBoundingClientRect().top;
    const startSlot = Math.floor(startY / slotHeight);

    const startHour = CALENDAR_DAY_START_HOUR + startSlot;
    const startMinutes = Math.floor((startY % slotHeight) / (slotHeight / 2)) * 30;

    const startTime = new Date(year, month, day, startHour, startMinutes);

    const endTime = new Date(startTime);
    endTime.setMinutes(endTime.getMinutes() + 30);

    setTempTask({ start: startTime, end: endTime });
  };

  // Handles mouse move to adjust the end time of the temporary task
  const handleMouseMove = (e) => {
    if (tempTask) {
      const currentY = e.clientY - e.currentTarget.getBoundingClientRect().top;
      const currentSlot = Math.floor(currentY / slotHeight);

      const endHour = CALENDAR_DAY_START_HOUR + currentSlot;
      const endMinutes = Math.round((currentY % slotHeight) / (slotHeight / 2)) * 30;
      const endTime = new Date(year, month, day, endHour, endMinutes);

      if (endTime > tempTask.start) {
        setTempTask((prevTask) => ({ ...prevTask, end: endTime }));
      }
    }
  };

  const handleMouseUp = () => {
    if (tempTask) {
      onAddAvailability(TASK_AVAILABILITY_TYPE, tempTask.start, tempTask.end);
      setTempTask(null);
    }
  };

  const columnDay = new Date(year, month, day);
  const dow = columnDay.getDay();
  const weekends = dow === 0 || dow === 6;
  const today = isToday(new Date(year, month, day));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(() => new Date());
    }, 60000); // 1 minute
    return () => clearInterval(interval);
  }, []);

  const ovebookingsCount = bookings.reduce((acc, booking) => {
    acc[booking.time_from] = (acc[booking.time_from] || 0) + 1;
    return acc;
  }, {});

  const timeslotOverbooked = booking => (ovebookingsCount[booking.time_from] || 0) > 1;

  return (
    <div className={cn('dayColumn', { '-weekends': weekends, '-today': today })}>
      <div className="header">
        <div className="day">{dayOfWeek2Text(dow)}</div>
        <div className="date">{day}</div>
        {/*<div className="month">{month2Text(month + 1)}</div>*/}
      </div>
      <div
        className="slots"
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
      >
        {hours.map(hour => (
          <TimeSlot key={hour} hour={hour} showTime={false} />
        ))}

        {tasks.map(task =>
          <Task key={task.id} task={task} onTaskClick={onTaskClick} />
        )}

        {today && (
          <div
            className={cn('currentTimeLine')}
            style={{top: `${calculatePositionFromTime(londonTime)}px`}}
          />
        )}

        {bookings.map(booking =>
          <Booking key={booking.id} booking={booking} onBookingClick={onBookingClick} overbooking={timeslotOverbooked(booking)} />
        )}

        {/* Render temporary task */}
        {tempTask && (
          <div
            className="task temporary"
            style={{
              top: `${calculatePositionFromTime(tempTask.start)}px`,
              height: `${calculatePositionFromTime(tempTask.end) - calculatePositionFromTime(tempTask.start)}px`,
            }}
          >
            new
          </div>
        )}
      </div>
    </div>
  );
};

export default DayColumn;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/DayColumn.js